<script>
    import Header from "./header-section.svelte";
    import Footer from "./footer.svelte";
    import { faqs, faqs_mob } from "./header_data.js";
    import { title } from "./store.js";
    title.set("Faqs");
    let faqs_data = [
        {
            question: "How much does it cost?",
            answer: "Since every project is unique, we price our services based on individual projects and not on an hourly rate. We will provide estimates on demand for busy contractors who need quick and easy numbers so that they can bid more projects. The pricing costs less than a full-time in-house estimator so outsourcing could work very well for you.",
        },
        {
            question: "What is your turn around or delivery time?",
            answer: "The usual delivery time for most projects is roughly a week. If the project is bigger, than it can take anywhere from 8 to 12 business days. We will give an estimated timeframe before starting the project so you can tell us if you want an earlier date and we will try our best to accommodate you. A small fee will be charged for overtime costs for a rushed project needing less than 6 days.",
        },
        {
            question: "What software do you use for estimating?",
            answer: "Automason using digital takeoff software to complete our quantities and an exclusive software to formulate the assemblies and pricing estimates. We get our pricing from Craftsman National Construction Estimator Database Suite which is updated regularly throughout the year. Moreover, the pricing is based on your zipcode so that the bid you’re making is extremely accurate and competitive.",
        },
        {
            question: "Where do you get your prices from?",
            answer: "We get our pricing from Craftsman National Construction Estimator Database Suite which is updated multiple times per year, and pricing is based on your project’s zip code so your bid will be as accurate and competitive as possible.",
        },
        {
            question: "What types of estimates do you do?",
            answer: "We specialize in Commercial, Residential, and Industrial projects. We perform estimates for Remodeling, New Construction, High Rises, Multifamily, Restaurants, Mixed-Use Retail and Residential, Warehouses, and more! We do estimates for General Contractors, Subcontractors, Developers, Architects, Owners, Lenders/Banks, Appraisers, Insurance Companies, and more.",
        },
        {
            question: "What if I don’t have plans for the project?",
            answer: "You don’t have to give us a plan if you don’t have one. If you have sketches, we can project costs accordingly or on the basis of the quantities you give us.",
        },
        {
            question: "Can you do estimates if the drawings are not completed?",
            answer: "Yes, we can. Our team works with architects and developers in the early stages of planning and design. All you have to do is send us your preliminary drawings and we can take it from there. We will provide the estimated costs of construction so that you can make more accurate decisions for purchasing and design aspects.",
        },
        {
            question: "How do I send you the plans for the project?",
            answer: "We make it easy to send us your plans. You can email us your Invitation to Bid Email to <a style='color:#3C88C3; font-weight: bold; ' href='mailto:hello@automason.ai'> hello@automason.com <a> with the trades you would like to bid.",
        },
        {
            question: "What payment methods to you accept?",
            answer: "We use secure Quickbooks Online Payments where you can easily pay with your Credit Card. Once you send us your plans, we’ll send you a Quickbooks Invoice prior to starting for you and your team to review. If you choose to proceed, you can easily make a payment through your Desktop, Mobile Phone, or you can call us directly to process the payment.",
        },
        {
            question: "How accurate are your estimates?",
            answer: "Our pricing is based on your project’s zip code so it will be highly accurate and market competitive. Our estimates are calculated as guides for you so that you can make the final prices according to your own budget. You can make adjustments on the Excel Spreadsheet we will send you and manually edit them if you want to. Our team consists of construction professionals that have extensive experience and will lend you a hand if you want knowledge on productivity or equipment. For example, if a wall is 20 ft high, you will need to include a lift along with slower productivity which in turn effects the labor price.  ",
        },
        {
            question: "What about the pricing for a take-off?",
            answer: "Every contractor worries about take-off prices and we offer a highly accurate construction cost database that gives us up to date labor and material pricing. It’s based on the zip-code, so your project will be as accurate and competitive as possible.",
        },
        {
            question: "Do you work with early basis projects?",
            answer: "Yes, we do have early assistance for projects. You can avail this opportunity for an added charge as we have to give extra commission to our team of estimators.",
        },
        {
            question: "Which trades do you cover?",
            answer: "We have a dedicated team of professionals who have ten years of experience in estimation. To remain competitive in the market, we have hired about 20 top estimators who can cover each trade of construction.",
        },
        {
            question: "Do you claim any guarantee for the project?",
            answer: "Yes, we do! Since we use a highly accurate cost database and the best tools for our takeoffs, we claim 98% accuracy for all of our take-offs.",
        },
        {
            question: "What is your turnaround time?",
            answer: "We calculate turnaround time after reviewing the plans you send us. Usually, it takes 2 or 3 business days for a 2000 sq feet which includes each work in it.",
        },
    ];
</script>

<Header
    data_desktop={faqs}
    data_mobile={faqs_mob}
    top={"100vw"}
    left_margin={"40vw"}
    line_stroke={"white"}
    logo_color={"white"}
    logo_stroke={"white"}
    Width_line="19vw"
/>
<div class="desktop">
    <div class="faqs-section">
        {#each faqs_data as faq, index}
            <div class="one-data">
                <div class="num-ques">
                    <div class="num">
                        <p class="num-text">{index + 1} -</p>
                    </div>
                    <div class="des">
                        <p style="font-weight: 600;">{faq.question}</p>
                    </div>
                </div>
                <div class="ans">
                    <p style="font-weight: 400;">{@html faq.answer}</p>
                </div>
            </div>
        {/each}
    </div>
</div>
<div class="mobile">
    <div class="faq_mob">
        {#each faqs_data as faq, index}
            <div class="mob-data">
                <div class="num-quest2">
                    <div class="num2">
                        <div class="num-text2">{index + 1} -</div>
                    </div>
                    <div class="quest">
                        <div style="font-weight: 600;">{faq.question}</div>
                    </div>
                </div>
                <div class="answer" style="font-weight: 400;">
                    {@html faq.answer}
                </div>
                {#if faqs_data.length - 1 != index}
    
      
                <hr />{/if}
            </div>
        {/each}
    </div>
</div>
<Footer />

<style>
    .faqs-section {
        margin-left: 17.604vw;
        margin-top: 5.833vw;
        margin-bottom: 6vw;
        /* font-family: 'Poppins'; */
    }
    .num-ques {
        display: flex;
        gap: 0.625vw;
    }
    .des {
        margin-top: -0.3vw;
    }
    .num {
        height: 1.563vw;
        width: 1.6vw;
    }
    .num-text {
        font-size: 0.833vw;
        font-weight: 500;
        color: #ff6d24;
    }
    .ans {
        width: 72.396vw;
        margin-left: 2.2vw;
        margin-top: -1.9vw;
        margin-bottom: 2.604vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }

        .mobile {
            display: block;
        }
    }

    /* mobile version*/

    .faq_mob {
        width: 73.953vw;
        height: auto;
        margin-left: 17.209vw;
        margin-top: 10vw;
    }

    .quest {
        font-size: 3.256vw;
        font-weight: 600;
        line-height: 4.651vw;
        text-align: left;
        margin-bottom: 6vw;
        margin-left: 1.5vw;
    }

    .num-quest2 {
        display: flex;
        gap: 0.625vw;
    }
    /*.num2{
height: 1.563vw;
width: 1.6vw;
}*/
    .num-text2 {
        color: #ff6d24;
        font-size: 2.791vw;
        font-weight: 500;
        line-height: 4.791vw;
        text-align: left;
        word-spacing: -0.5vw;
        margin-left: -7vw;
        margin-bottom: 5vw;
    }
    .answer {
        width: 72.396vw;
        margin-left: 2.2vw;
        margin-bottom: 7.604vw;
        font-family: "Poppins";
        font-size: 2.791vw;
        font-weight: 400;
        line-height: 4.791vw;
        text-align: left;
    }

    hr {
        margin-left: -18vw;
        margin-bottom: 7vw;
        border: solid #eae7e7 0.233vw;
        width: 100vw;
        background: #eae7e7;
    }
</style>
